/**
 * Read WxH from an image File for attachment meta.imageSize (chat bubble layout).
 * Returns null for non-images or decode failures.
 */
const readImageSize = file => {
  if (!file?.type?.startsWith('image/') || typeof URL.createObjectURL !== 'function') {
    return Promise.resolve(null);
  }
  return new Promise(resolve => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      const width = img.naturalWidth || img.width;
      const height = img.naturalHeight || img.height;
      resolve(width && height ? `${width}x${height}` : null);
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve(null);
    };
    img.src = url;
  });
};

export default readImageSize;
